export const soundsTextContent = {
  headingText: "Sounds",
  paraText: "Every game comes with the ideal sound mix and effects that are responsible for the highly immersive slot experiences. From impeccable background music to thrilling spinning reel sounds, from bonus round sound effects to jackpot score, our sound mixes create unforgettable gambling experiences for your customer.",
  btnText: "Contact Us",
  imageSrc: "/assets/stock-img/sounds_img.webp",
};
